module.exports = __webpack_public_path__ + "img/down-arrow.9520c416.svg";